import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import { useTheme } from '../../ThemeContext';

import { userDeleteInit, userDelete } from '../../actions/User/UserActions';

import Modal from '../Modal';

import {
  Form,
  Wrapper,
  Header,
  Title,
  Content,
  Footer,
  Button,
  Box,
  Textbox,
  Text,
  Deco,
} from './ProfileManageUsersManageUser.style';

const ProfileManageUsersManageUserInner = ({
  data,
  handleClose = () => {},
}) => {
  const intl = useIntl();
  const theme = useTheme();
  const firebaseStore = useSelector((state) => state.firebase);
  const { auth } = firebaseStore;
  const userDeleteStore = useSelector((state) => state.userDeleteStore);
  const { isLoading, isSuccess, isError, error } = userDeleteStore;
  const dispatch = useDispatch();

  const onSubmit = (e) => {
    try {
      e.preventDefault();
      if (data && data.id !== auth.uid) dispatch(userDelete({ id: data.id }));
    } catch {}
  };

  useEffect(() => {
    dispatch(userDeleteInit());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderSuccessPanel = () => {
    return (
      <Wrapper theme={theme.profileManageUsersManageUser.wrapper}>
        <Header theme={theme.profileManageUsersManageUser.header}>
          <Title theme={theme.profileManageUsersManageUser.title}>
            {intl.formatMessage({
              id: 'PROFILE_MANAGE_USERS_MANAGE_USER.SUCCESS',
            })}
          </Title>
        </Header>
        <Content>
          <Box>
            <Textbox center>
              <Text theme={theme.profileManageUsersManageUser.text.default}>
                {intl.formatMessage({
                  id: `PROFILE_MANAGE_USERS_MANAGE_USER.TEXT.THE_USER_HAS_BEEN_SUCCESSFULLY_DELETED`,
                })}
              </Text>
            </Textbox>
          </Box>
        </Content>
        <Footer>
          <Button
            type='button'
            theme={theme.button.default}
            onClick={() => {
              handleClose();
            }}
          >
            {intl.formatMessage({ id: 'PROFILE_MANAGE_USERS_MANAGE_USER.OK' })}
          </Button>
        </Footer>
      </Wrapper>
    );
  };

  return (
    <>
      {isSuccess ? (
        renderSuccessPanel()
      ) : (
        <Form onSubmit={onSubmit}>
          <Wrapper theme={theme.profileManageUsersManageUser.wrapper}>
            <Header theme={theme.profileManageUsersManageUser.header}>
              <Title theme={theme.profileManageUsersManageUser.title}>
                {intl.formatMessage({
                  id: 'PROFILE_MANAGE_USERS_MANAGE_USER.DELETE_USER',
                })}
              </Title>
            </Header>
            <Content>
              <Box>
                <Textbox center>
                  <Text theme={theme.profileManageUsersManageUser.text.default}>
                    {intl.formatMessage(
                      {
                        id: `PROFILE_MANAGE_USERS_MANAGE_USER.TEXT.ARE_YOU_SURE_WANT_TO_DELETE_USER`,
                      },
                      {
                        deco: (children) => (
                          <Deco
                            theme={theme.profileManageUsersManageUser.text.deco}
                          >
                            {children}
                          </Deco>
                        ),
                        name: data && data.full_name,
                      }
                    )}
                    <br />
                    {intl.formatMessage({
                      id: `PROFILE_MANAGE_USERS_MANAGE_USER.TEXT.THIS_OPERATION_CANNOT_BE_UNDONE`,
                    })}
                  </Text>
                </Textbox>
              </Box>
            </Content>
            {isError ? (
              <Textbox>
                <Text theme={theme.profileManageUsersManageUser.text.error}>
                  {intl.formatMessage({
                    id: `PROFILE_MANAGE_USERS_MANAGE_USER.TEXT.ERROR.${error}`,
                    defaultMessage: error,
                  })}
                  .
                </Text>
              </Textbox>
            ) : (
              ''
            )}
            <Footer>
              <Button
                type='button'
                theme={theme.button.alt}
                disabled={isLoading}
                onClick={() => {
                  handleClose();
                }}
              >
                {intl.formatMessage({
                  id: 'PROFILE_MANAGE_USERS_MANAGE_USER.CANCEL',
                })}
              </Button>
              <Button
                theme={theme.button.default}
                disabled={isLoading || !(data && data.id !== auth.uid)}
              >
                {isLoading
                  ? intl.formatMessage({
                      id: 'PROFILE_MANAGE_USERS_MANAGE_USER.PLEASE_WAIT',
                    })
                  : intl.formatMessage({
                      id: `PROFILE_MANAGE_USERS_MANAGE_USER.DELETE`,
                    })}
              </Button>
            </Footer>
          </Wrapper>
        </Form>
      )}
    </>
  );
};

const ProfileManageUsersManageUser = ({ data, handleClose = () => {} }) => {
  return (
    <Modal handleClose={handleClose}>
      <ProfileManageUsersManageUserInner
        data={data}
        handleClose={handleClose}
      />
    </Modal>
  );
};

ProfileManageUsersManageUserInner.propTypes = {
  data: PropTypes.object,
  handleClose: PropTypes.func,
};

ProfileManageUsersManageUser.propTypes = {
  data: PropTypes.object,
  handleClose: PropTypes.func,
};

export default ProfileManageUsersManageUser;
